import { useEffect } from "react";
import { FlowState } from "./types";

export const usePageUnloadWarning = (flowState: FlowState) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Standard way to show a confirmation prompt.
      event.preventDefault();
      event.returnValue = ""; // Required for Chrome and other modern browsers.
    };

    // These are the states where navigating away would cause data loss.
    const shouldShowWarning = [
      "processing",
      "generalExtracted",
      "detailedProcessing",
      "detailedExtracted",
      "saving",
    ].includes(flowState);

    if (shouldShowWarning) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    // The cleanup function will remove the listener when the component unmounts
    // or when the flowState changes to a "safe" state.
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [flowState]);
};